import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { InternalI18n } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/i18n/internal-i18n-controller.js';
import { property, query, state } from 'lit/decorators.js';
import { debounce } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/debounce.js';
import { gridBreakpoints } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/breakpoints.js';
import { addStyleSheetToElements } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/cssstylesheet-interface.js';
import { sanitizeSearch, searchWord } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/search.js';
import styles from './search.scss.js';
import '@cigna/cigna_csg_gsg_cipublic-icon/cipublic-icon.js';
import '@cigna/cigna_csg_gsg_cipublic-form/cipublic-form.js';
import '@cigna/cigna_csg_gsg_cipublic-input/cipublic-input.js';
import '@cigna/cigna_csg_gsg_cipublic-button/cipublic-button.js';
import inputStyles from './input.scss.js';
sanitizeSearch(searchWord);
/**
 * @element cipublic-search
 */
export class Search extends CipublicElement {
    constructor() {
        super(...arguments);
        this.i18n = new InternalI18n(this);
        this.action = '/search';
        this.inline = false;
        this.required = false;
    }
    get isMobile() {
        return !window.matchMedia(`(min-width: ${gridBreakpoints.lg}px)`).matches;
    }
    async firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        addStyleSheetToElements([this.cipublicInput], inputStyles);
        await this.updateComplete;
        this.windowWidth = window.innerWidth;
        if (this.inline) {
            window.addEventListener('resize', () => debounce(() => {
                if (this.windowWidth !== window.innerWidth) {
                    this.windowWidth = window.innerWidth;
                    this.requestUpdate();
                }
            }, 250));
        }
    }
    render() {
        return html `<cipublic-form action="${this.action}" method="GET"><cipublic-input button-as-submit error-value-missing="${this.inline || !this.required ? '' : this.i18n.t('searchError')}" ?inline="${this.inline}" label="${this.i18n.t('search')}" ?labelVisuallyHidden="${this.inline ? this.isMobile : true}" name="query" optional="${this.inline ? '' : this.i18n.t('optional')}" placeholder="${this.inline ? this.i18n.t('search') : ''}" ?required="${this.inline ? false : this.required}" type="search" value="${searchWord}"><cipublic-button slot="button" variant="primary" icononly type="submit"><cipublic-icon set="system" name="search" aria-label="${this.i18n.t('search')}" role="img"></cipublic-icon></cipublic-button></cipublic-input></cipublic-form>`;
    }
}
Search.styles = styles;
__decorate([
    property({ reflect: true })
], Search.prototype, "action", void 0);
__decorate([
    query('cipublic-input')
], Search.prototype, "cipublicInput", void 0);
__decorate([
    property({ reflect: true, type: Boolean })
], Search.prototype, "inline", void 0);
__decorate([
    state()
], Search.prototype, "isMobile", null);
__decorate([
    state()
], Search.prototype, "windowWidth", void 0);
__decorate([
    property({ reflect: true, type: Boolean })
], Search.prototype, "required", void 0);
//# sourceMappingURL=search.js.map